import React from "react";
import { ShieldCheck, Landmark, Scale } from "lucide-react";
import { hero } from "../mock";

import { tr } from "../i18n";
const badgeIcons = [ShieldCheck, Landmark, Scale];

export default function Hero({ onIllustration }) {
  return (
    <section className="relative bg-[#0b1f3a] overflow-hidden pt-[130px] md:pt-[150px] pb-16 md:pb-24">
      {/* Decorative gold arcs */}
      <div className="pointer-events-none absolute -top-24 -right-24 w-[520px] h-[520px] rounded-full border border-[#c2a15a]/15" />
      <div className="pointer-events-none absolute -top-10 -right-10 w-[360px] h-[360px] rounded-full border border-[#c2a15a]/10" />
      <div className="pointer-events-none absolute bottom-0 left-0 w-full h-40 bg-gradient-to-t from-[#08192f] to-transparent" />

      <div className="max-w-7xl mx-auto px-5 md:px-8 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-8 items-center">
          {/* Left */}
          <div>
            <p className="text-[#c2a15a] text-[13px] tracking-[0.25em] uppercase mb-5">
              {hero.eyebrow}
            </p>
            <h1 className="font-display text-white text-[44px] leading-[1.05] sm:text-[56px] md:text-[68px] font-medium mb-6">
              {hero.title}
              <br />
              <span className="text-[#c2a15a] italic">{hero.titleAccent}</span>
            </h1>
            <p className="text-white/70 text-[17px] md:text-[19px] leading-relaxed max-w-xl mb-8">
              {hero.subtitle}
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-12">
              <button
                onClick={onIllustration}
                className="inline-flex items-center justify-center gap-2 border border-white/25 hover:border-[#c2a15a] text-white hover:text-[#c2a15a] font-medium uppercase tracking-wide text-[14px] px-7 py-4 rounded-full transition-colors"
              >
                {hero.secondaryCta}
              </button>
            </div>

            {/* Badges */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
              {hero.badges.map((b, i) => {
                const Icon = badgeIcons[i];
                return (
                  <div key={i} className="flex items-center gap-3">
                    <div className="w-11 h-11 rounded-full bg-white/5 ring-1 ring-[#c2a15a]/40 flex items-center justify-center shrink-0">
                      <Icon size={20} className="text-[#c2a15a]" />
                    </div>
                    <p className="text-white/70 text-[13px] leading-tight">
                      {b.label}
                      <br />
                      <span className="text-white font-medium">{b.strong}</span>
                    </p>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Right image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden ring-1 ring-[#c2a15a]/30 shadow-2xl shadow-black/40">
              <img
                src={hero.image}
                alt={tr("City of London financial district")}
                className="w-full h-[380px] md:h-[520px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0b1f3a]/70 via-transparent to-transparent" />
              {/* Floating stat card */}
              <div className="absolute bottom-5 left-5 right-5 md:right-auto md:w-[260px] bg-white/95 backdrop-blur rounded-xl p-4 shadow-xl">
                <p className="text-[12px] text-[#0b1f3a]/60 uppercase tracking-wide">
                  {tr("Blended average rate")}
                </p>
                <p className="font-display text-[34px] text-[#0b1f3a] leading-none mt-1">
                  4.66<span className="text-[#c2a15a]">%</span>
                </p>
                <p className="text-[12px] text-[#0b1f3a]/60 mt-1">
                  {tr("across 55+ partner institutions")}
                </p>
              </div>
            </div>
            {/* gold accent square */}
            <div className="hidden md:block absolute -top-5 -left-5 w-24 h-24 border-2 border-[#c2a15a]/40 rounded-xl -z-0" />
          </div>
        </div>
      </div>
    </section>
  );
}
